export default __webpack_public_path__ + "static/apai-a36ecf560672c6374195d4b23db7c2b3.png";